import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'issue.views.common.child-issues-panel.heading.inline-header-message-info-panel.title',
		defaultMessage: 'You can no longer create subtasks within epics',
		description: 'Information Panel Title',
	},
	coreMessage: {
		id: 'issue.views.common.child-issues-panel.heading.inline-header-message-info-panel.core-message',
		defaultMessage: 'Existing subtasks will be merged into the work item panel.',
		description: 'Key message for the information panel',
	},
	createActionMessage: {
		id: 'issue.views.common.child-issues-panel.heading.inline-header-message-info-panel.create-action-message',
		defaultMessage:
			'You can still create work items by selecting + Add under the summary, or the + on the right of the child work items panel header.',
		description: 'Action items users can take to create work items',
	},
	communityPostLink: {
		id: 'issue.views.common.child-issues-panel.heading.inline-header-message-info-panel.community-post-link',
		defaultMessage: 'Read our Community post',
		description: 'Community post link text',
	},
});
